"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLocale = exports.getValidLocale = exports.extractSlugLocale = exports.getLocalePattern = void 0;
const common_1 = require("@epic-core/common");
const LocaleHandler_1 = require("./LocaleHandler");
const DEFAULT_LOCALE = 'en-US';
/**
 * A safe to use locale pattern regex.
 */
function getLocalePattern(negativeLookupArray) {
    if (negativeLookupArray && negativeLookupArray.length) {
        const negativeLookupStr = negativeLookupArray.join('|');
        return new RegExp(`^${(0, common_1.getPath)()}((?!${negativeLookupStr})[a-zA-Z0-9]{2}(?:[-_][a-zA-Z0-9]{2,4}){0,2})(/.*)?$`);
    }
    return new RegExp(`^${(0, common_1.getPath)()}([a-zA-Z0-9]{2}(?:[-_][a-zA-Z0-9]{2,4}){0,2})(/.*)?$`);
}
exports.getLocalePattern = getLocalePattern;
function extractSlugLocale(pathname, locale) {
    const matches = getLocalePattern().exec(pathname);
    //remove locale path from url if locale is present
    let pageSlug = pathname;
    let pageLocale;
    if (matches && matches.length && matches[1] && matches[2]) {
        pageSlug = matches[2];
        pageLocale = locale || matches[1] || DEFAULT_LOCALE;
    }
    else {
        pageLocale = locale || DEFAULT_LOCALE;
    }
    return { pageSlug, pageLocale };
}
exports.extractSlugLocale = extractSlugLocale;
/**
 *
 *  Check whether or not the locale is supported in the app
 *  otherwise, return default locale
 */
function getValidLocale(locale, config) {
    if (config && config.allLocales) {
        if ((0, LocaleHandler_1.isLocaleSupported)(locale, config)) {
            return locale;
        }
    }
    else {
        console.warn(`getValidLocale() -> config.allLocales not found, could not properly process locale`);
    }
    return DEFAULT_LOCALE;
}
exports.getValidLocale = getValidLocale;
/**
 *  Resolve the current valid locale from the request context
 *
 *  locale resolving ordering:
 *
 *      1. param
 *      2. cookie
 *      3. accept-lang
 */
function resolveLocale(req, config) {
    const paramLocale = (0, LocaleHandler_1.getLocaleDataFromParams)(req, config);
    const cookieLocale = req.universalCookies && (0, LocaleHandler_1.getLocaleFromCookie)(req, config);
    const acceptLocale = (0, LocaleHandler_1.getLocaleFromAcceptLang)(req, config);
    let locale = null;
    // 1. Try to set locale from params
    if (!locale && paramLocale) {
        locale = paramLocale;
    }
    // 2. Try to set locale from cookies
    if (!locale && cookieLocale) {
        locale = cookieLocale;
    }
    // 3. Try to set locale from accept lang
    if (!locale && acceptLocale) {
        locale = acceptLocale;
    }
    // Set locale to be default as final fallback
    if (!locale) {
        locale = DEFAULT_LOCALE;
    }
    // process the locale to test whether or not it is valid based on app configuration
    locale = getValidLocale(locale, config);
    return locale;
}
exports.resolveLocale = resolveLocale;
//# sourceMappingURL=utils.js.map